module.exports = __webpack_public_path__ + "static/media/ap5.e3b6bf91.jpeg";